/**
 * This function changes the url using replaceState API, wich operates as history.pushState() exept
 * that it modifies the current history entry instead of creating a new one
 * @param {String} toAppend url to replace in the browser history
 */
export const changeUrlNoHistory = (toAppend) => {
  history.replaceState(null, null, toAppend);
};

/**
 * This function changes the url using the pushState API creating a new history entry in the
 * history stack
 * @param {String} toAppend url to add to the browser history
 */
export const changeUrlAndHistory = (toAppend) => {
  history.pushState(null, null, toAppend);
};
